
import {getDistance} from 'geolib';
import {AllRegions} from 'utils/region';

import {Coords, Region} from './types';

// We multiply by 1610 meters per mile
const maxMetersToRegion = 1610 * 100;

export const calcRegion = (coords?: Coords): Region | undefined => {
	if (!coords) {
		return;
	}

	let closest = {
		region: undefined as (Region | undefined),
		distance: 0,
	};

	for (const region of AllRegions) {
		const distance = getDistance(coords, region.center);
		if (!closest.region || distance < closest.distance) {
			closest = {
				region,
				distance,
			};
		}
	}

	if (closest.distance > maxMetersToRegion) {
		return;
	}

	return closest.region;
};
